<script lang="ts" setup>
import { ref } from 'vue';

import {
  LabelFormatter,
  getLabelFormatterPropsForRangeValue,
} from '@apps/main/new-desktop/core/components/formatters';
import type { LabelFormatterTypes } from '@apps/main/new-desktop/core/components/formatters';

import { AppSlider } from '@libs/ui';

import { FilterType, FilterUpdateEventType } from '../../Filters.model';

import type {
  RangeSliderUpdateFilterEvent,
  RangeSliderFilterData,
} from './RangeSliderFilter.model';

interface FlightsFiltersProps {
  data: RangeSliderFilterData;
}

const props = defineProps<FlightsFiltersProps>();

interface RangeSliderFilterEmits {
  (eventName: 'update', context: RangeSliderUpdateFilterEvent): void;
}

const emit = defineEmits<RangeSliderFilterEmits>();

const labelFormatter = ref<LabelFormatterTypes | undefined>();

function update(range: number[]): void {
  emit('update', {
    eventType: FilterUpdateEventType.UpdateFilter,
    filterType: FilterType.RangeSlider,
    range,
    ingredientId: props.data.options.id,
  });
}

function updateLabel(value: number[]): void {
  labelFormatter.value = getLabelFormatterPropsForRangeValue(
    props.data.labelFormatter,
    value
  );
}
</script>

<template>
  <div class="range-slider-filter">
    <p v-if="props.data.title" class="title">{{ props.data.title }}</p>
    <LabelFormatter :data="labelFormatter || props.data.labelFormatter" />
    <AppSlider
      v-bind="props.data.options"
      @update-range="update"
      @slide-range="updateLabel"
    />
  </div>
</template>

<style scoped lang="scss">
.range-slider-filter {
  .title {
    @include font-label-l-light;
  }
}
</style>
